import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const PostulanteService = {
    fetchPostulantes: async ({ token,desde, hasta,nombre, estado,order, page = 1, limit = 20 }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/postulantes'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { estado,desde, hasta,nombre,order, page, limit },
            });

            return {
                postulantes: response.data.postulantes || [],
                totalPages: response.data.totalPages || 1,
                totalRegistros: response.data.total || 0,
            };
        } catch (error) {
            console.error('Error en PostulanteService.fetchPostulantes:', error);
            throw error;
        }
    },
    registrarPostulante: async (token, datosPostulante) => {
        try {
            const response = await axios.post(buildApiUrl('/api/postulantes'), datosPostulante, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.registrarPostulante:', error);
            throw error;
        }
    },
    fetchPostulanteById: async (token, id) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/postulantes/${id}`), {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.fetchPostulanteById:', error);
            throw error;
        }
    },
    actualizarPostulante: async (token, id, datosActualizados) => {
        try {
            const response = await axios.put(buildApiUrl(`/api/postulantes/${id}`), datosActualizados, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.actualizarPostulante:', error);
            throw error;
        }
    },
    contactarPostulante: async (token, id, datosContacto) => {
        try {
            const response = await axios.post(
                buildApiUrl(`/api/postulantes/${id}/contactar`),
                datosContacto,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.contactarPostulante:', error);
            throw error;
        }
    },
    entrevistarPostulante: async (id, formData, token) => {
        try {
            const response = await axios.post(
                buildApiUrl(`/api/postulantes/${id}/entrevistar`),
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error al entrevistar postulante:', error);
            throw error;
        }
    }
};
